import script from "./CurrentFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentFilters.vue?vue&type=script&setup=true&lang=js"

import "./CurrentFilters.vue?vue&type=style&index=0&id=75decd08&lang=scss"

const __exports__ = script;

export default __exports__